require("../../node_modules/cookieconsent/build/cookieconsent.min.js");



window.addEventListener("load", function () {
    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "#00263E",
                "text": "#00B5E2"
            },
            "button": {
                "background": "#FF8200",
                "text": "#212322"
            }
        },
        "theme": "edgeless",
        "position": "bottom-left",
        "type": "info",
        "cookie": {
            "domain": ".agile-is.de"
        },
        "content": window.ais && window.ais.cookieconsent && window.ais.cookieconsent.content || {
            "message": "Diese Website verwendet Cookies. Indem Sie weiter auf dieser Website navigieren, ohne die Cookie-Einstellungen Ihres Internet Browsers zu ändern, stimmen Sie unserer Verwendung von Cookies zu.",
            "dismiss": "OK",
            "link": "Mehr Informationen",
            "href": "/datenschutz"
        },
        "revokable": false,
        onInitialise: function (status) {
            // var type = this.options.type;
            // if (type == 'info' && status === "dismiss") {
            //     /* enable cookies */
            //     ga('create', 'UA-36721717-1', 'auto');
            //     ga('set', 'anonymizeIp', true);
            //     ga('send', 'pageview');
            // } else {
            //     /* disable cookies */
            //     window['ga-disable-UA-36721717-1'] = true;
            //     deleteCookie('_ga');
            //     deleteCookie('_gid');
            //     deleteCookie('_gat');
            // }
        },
        onStatusChange: function (status, chosenBefore) {
            // var type = this.options.type;
            // if (type == 'info' && status === "dismiss") {
            //     /* enable cookies */
            //     delete window['ga-disable-UA-36721717-1'];
            //     ga('create', 'UA-36721717-1', 'auto');
            //     ga('set', 'anonymizeIp', true);
            //     ga('send', 'pageview');
            // } else {
            //     /* disable cookies */
            //     window['ga-disable-UA-36721717-1'] = true;
            //     deleteCookie('_ga');
            //     deleteCookie('_gid');
            //     deleteCookie('_gat');
            // }
        },
        onRevokeChoice: function () {
            // var type = this.options.type;
            // if (type == 'opt-in') {
            //     /* disable cookies */
            //     window['ga-disable-UA-36721717-1'] = true;
            //     deleteCookie('_ga');
            //     deleteCookie('_gid');
            //     deleteCookie('_gat');
            // }
        }
    });
});